module.exports = __webpack_public_path__ + "static/media/burger.bcf1b5b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/burger.png
// module id = 39
// module chunks = 0